import * as React from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import "mapbox-gl/dist/mapbox-gl.css";
import { Button } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../../shared/stores/RootStore";

const RouteMatchingControlsBase: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { osaNodeStore, osaWayStore } = useStores();

  const way = osaWayStore.getSelected()!;

  const matchRoute = async () => {
    setLoading(true);
    const nodes = osaNodeStore.getMultiSelectedNodesByOsaWay(way.id);
    await osaNodeStore.matchRoute(nodes!);
    setLoading(false);
  };

  return (
    <Button
      colorPalette="primary"
      size="sm"
      loading={loading}
      onClick={matchRoute}
      disabled={osaNodeStore.multiSelectedIds.size < 2}
    >
      {t(`osaway:mapBoxMatching.mapboxMatchButton`)}
    </Button>
  );
};

export const RouteMatchingControls = observer(RouteMatchingControlsBase);
